// libs
import { styled } from '@nykaa/ui-components';

// components
import WidgetTopRef from 'shared/layouts/DetailsPage/components/WidgetLoader/components/WidgetTopRef';

// constants
import {
  MWEB_HEADER_HEIGHT,
  DWEB_PRIMARY_HEADER_HEIGHT,
  DWEB_SECONDARY_HEADER_HEIGHT,
  PROMO_BANNER_HEIGHT,
} from 'shared/styles/base';

const DWEB_HEADER_HEIGHT =
  DWEB_PRIMARY_HEADER_HEIGHT + DWEB_SECONDARY_HEADER_HEIGHT + PROMO_BANNER_HEIGHT;

export const WidgetTopDesktopRef = styled(WidgetTopRef)`
  & > .pointer {
    top: -${DWEB_HEADER_HEIGHT}px;
  }
`;

export const WidgetTopMobileRef = styled(WidgetTopRef)`
  & > .pointer {
    top: -${MWEB_HEADER_HEIGHT + 5}px;
  }
`;
